import { PiggyBank } from 'lucide-react';

import { PlanLogo as PlanLogoUi } from 'components/ui/plan-logo';
import { PlanSummary } from './planTypes';

/**
 * Adaptador de PANTALLA sobre `ui/PlanLogo` (el componente distribuible): traduce un `PlanSummary`
 * a la imagen de su gestora, que es dato de negocio y por eso no vive en el sistema de diseño.
 * Réplica estática del `PlanLogo.tsx` de chirigota (rama sin mergear feature/resumen-multi-plan,
 * `src/components/ResumenV2/PlanLogo.tsx`): mismo mapa de logos por `plan.id`.
 *
 * El plan de empleo se gestiona también vía Indexa en producción, así que comparte logo con el
 * plan individual de Indexa (variante "-icon", isotipo apilado en vez del wordmark horizontal,
 * pensada para una insignia pequeña).
 */
export const PLAN_LOGO_SRC: Record<string, string> = {
	empleo: '/imgs/indexa-capital-icon.png',
	individual: '/imgs/indexa-capital-icon.png',
	individual2: '/imgs/caser-helvetia.png',
	'empleo-suspendido': '/imgs/indexa-capital-icon.png'
};

export interface PlanLogoProps {
	plan: PlanSummary;
	className?: string;
}

export const PlanLogo = ({ plan, className }: PlanLogoProps) => (
	<PlanLogoUi
		src={plan.logoSrc ?? PLAN_LOGO_SRC[plan.id]}
		name={plan.name}
		className={className}
		fallback={
			<PiggyBank
				data-testid="plan-logo-fallback"
				className="h-1/2 w-1/2 text-primary"
				aria-hidden="true"
			/>
		}
	/>
);
